/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import InsuranceClaimHistory from './insurance-claim-history';
import InsuranceClaimHistoryDetail from './insurance-claim-history-detail';
import InsuranceClaimHistoryUpdate from './insurance-claim-history-update';
import InsuranceClaimHistoryDeleteDialog from './insurance-claim-history-delete-dialog';

const InsuranceClaimHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<InsuranceClaimHistory />} />
    <Route path="new" element={<InsuranceClaimHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<InsuranceClaimHistoryDetail />} />
      <Route path="edit" element={<InsuranceClaimHistoryUpdate />} />
      <Route path="delete" element={<InsuranceClaimHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InsuranceClaimHistoryRoutes;
